module.exports = __webpack_public_path__ + "fb-tutorial-4-en.png?c68947d26cdf82eca3ffe4d36bc5165f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-4-en.png
// module id = fhX6
// module chunks = 46